<article class="notification-card">
  <div class="notification-card-layout">
    <div class="notification-card-icon-wrapper">
      <mat-icon
        [svgIcon]="statusIcon.name"
        class="notification-card-status-icon"
        [style.color]="statusIcon.color"
        [style.width]="statusIcon.width"
        [style.height]="statusIcon.height"
        [style.font-size]="statusIcon.height"
      >
      </mat-icon>
    </div>

    <div class="notification-card-content">
      <h3 class="notification-card-title">{{ item.notificationType }} &mdash; {{ item.status }}</h3>
      <p *ngIf="showClientName" class="notification-card-client-name">{{ item.clientName }}</p>
      <a
        class="notification-card-study-link"
        [routerLink]="['/portfolio/study-details', item.studySk]"
      >
        Study {{ item.protocolNumber }}
      </a>
      <p class="notification-card-line">{{ item.description }}</p>
      <p class="notification-card-line">{{ item.date }}</p>
    </div>
  </div>
</article>
